import { SUPPORT_EMAIL, SUPPORT_URL } from 'constants/index';
import { ENV } from 'constants/env';
import { useYBugApi } from 'modules/app/YBugContext';
import { useWalkthrough } from 'modules/walkthrough/context';

export interface SupportAction {
  id: string;
  title: string;
  icon: JSX.Element;
  action: () => void;
  isShown: boolean;
  topDivider?: boolean;
}

/**
 * Hook for accessing support-related actions shared between components
 */
export const useSupportActions = () => {
  const yBugApi = useYBugApi();
  const { reset } = useWalkthrough();

  const isYBugAvailable = yBugApi && ENV.VITE_YBUG_ID;

  const restartWalkthrough = () => {
    reset();
  };

  const openYbugReport = () => {
    // If Ybug is available, open the feedback form
    if (isYBugAvailable) {
      yBugApi?.open('feedback');
    } else {
      // Otherwise, as an alternative, trigger an email to the support team
      window.location.href = `mailto:${SUPPORT_EMAIL}?subject=Report an Issue`;
    }
  };

  const navigateToSupport = () => {
    window.open(SUPPORT_URL, '_blank');
  };

  return {
    isYBugAvailable,
    restartWalkthrough,
    openYbugReport,
    navigateToSupport,
  };
};
